/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Backup_User_Settings_DescInputs */

const en_backup_user_settings_desc = /** @type {(inputs: Backup_User_Settings_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backup user settings`)
};

const fr_backup_user_settings_desc = /** @type {(inputs: Backup_User_Settings_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sauvegarder les paramètres utilisateur`)
};

const de_backup_user_settings_desc = /** @type {(inputs: Backup_User_Settings_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzereinstellungen sichern`)
};

const it_backup_user_settings_desc = /** @type {(inputs: Backup_User_Settings_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backup delle impostazioni utente`)
};

const ru_backup_user_settings_desc = /** @type {(inputs: Backup_User_Settings_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Резервное копирование пользовательских настроек`)
};

const es_backup_user_settings_desc = /** @type {(inputs: Backup_User_Settings_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia de seguridad de la configuración del usuario`)
};

const zh_cn2_backup_user_settings_desc = /** @type {(inputs: Backup_User_Settings_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`备份用户设置`)
};

const ja_backup_user_settings_desc = /** @type {(inputs: Backup_User_Settings_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザー設定のバックアップ`)
};

const hi_backup_user_settings_desc = /** @type {(inputs: Backup_User_Settings_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपयोगकर्ता सेटिंग्स का बैकअप लें`)
};

const pt_pt2_backup_user_settings_desc = /** @type {(inputs: Backup_User_Settings_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer backup das configurações do usuário`)
};

/**
* | output |
* | --- |
* | "Backup user settings" |
*
* @param {Backup_User_Settings_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const backup_user_settings_desc = /** @type {((inputs?: Backup_User_Settings_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Backup_User_Settings_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_backup_user_settings_desc(inputs)
	if (locale === "de") return de_backup_user_settings_desc(inputs)
	if (locale === "it") return it_backup_user_settings_desc(inputs)
	if (locale === "ru") return ru_backup_user_settings_desc(inputs)
	if (locale === "es") return es_backup_user_settings_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_backup_user_settings_desc(inputs)
	if (locale === "ja") return ja_backup_user_settings_desc(inputs)
	if (locale === "hi") return hi_backup_user_settings_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_backup_user_settings_desc(inputs)
	return en_backup_user_settings_desc(inputs)
});